import { styled } from 'topwrite';

interface Props {
    url?: string;
    image: string;
}

export default function Ad({ url, image }: Props) {
    return <Container><a target='_blank' href={url}>
        <img src={image} />
    </a></Container>;
}

const Container = styled.p`
  margin: 1em 0;

  a {
    width: 100%;  
    display: flex;
  }

  img {
    max-width: 100%;
    width: 100%;
  }

  &:first-child {
    margin-top: 0;
  }

  &:last-child {
    margin-bottom: 0;
  }
`;

